<template>
    <div>
        <div class="top-banner"></div>
        <div class="develop-tools">
            <div class="develop-tools-title">人脸工具包</div>
            <div class="bottom_hint"></div>
            <ul class="face-tools-list">
                <li class="face-tools-item" @click="clickToolsItem(0)">
                    <img src="@/assets/img/develop/develop_tools_1.png">
                    <div class="face-tools-item-title">人脸公安比对</div>
                    <div class="face-tools-item-des">将人像与公安库中的实际身份证照片进行比对，以判断是否为‘本人’</div>
                </li>
                <li class="face-tools-item" @click="clickToolsItem(1)">
                    <img src="@/assets/img/develop/develop_tools_2.png">
                    <div class="face-tools-item-title">人脸KYC认证</div>
                    <div class="face-tools-item-des">基于人脸识别的KYC认证服务，确保当事人是本人，且是真人</div>
                </li>
                <li class="face-tools-item" @click="clickToolsItem(2)">
                    <img src="@/assets/img/develop/develop_tools_3.png">
                    <div class="face-tools-item-title">FaceID验证</div>
                    <div class="face-tools-item-des">基于人脸识别的FaceID服务，可代替手机号作为唯一身份标识</div>
                </li>
            </ul>
        </div>
        <div class="develop-resolve-case">
            <div class="resolve-case-title">企业支付中心解决方案</div>
            <div class="bottom_hint"></div>
            <ul class="resolve-case-list">
                <li class="resolve-case-item" @click="clickCaseItem(0)">
                    <img src="@/assets/img/develop/resolve_case_industry_1.png">
                    <div class="resolve-case-item-title">企业自营</div>
                    <div class="resolve-case-item-des">适用于企业线上、线下面向消费者直销商品、服务等</div>
                </li>
                <li class="resolve-case-item" @click="clickCaseItem(1)">
                    <img src="@/assets/img/develop/resolve_case_industry_2.png">
                    <div class="resolve-case-item-title">批发商直销</div>
                    <div class="resolve-case-item-des">适用于企业向下游批发供货，下游收货后，基于订单实时付款给上游供应商</div>
                </li>
                <li class="resolve-case-item" @click="clickCaseItem(2)">
                    <img src="@/assets/img/develop/resolve_case_industry_3.png">
                    <div class="resolve-case-item-title">企业平台化销售</div>
                    <div class="resolve-case-item-des">适用于总部-分店、网络平台-商户入驻、商场-商户入驻等平台化运作的企业</div>
                </li>
                <li class="resolve-case-item" @click="clickCaseItem(3)">
                    <img src="@/assets/img/develop/resolve_case_industry_4.png">
                    <div class="resolve-case-item-title">企业平台+多渠道推广销售</div>
                    <div class="resolve-case-item-des">适用于需要将资金灵活分账给各推广方的以渠道及网络社交推广为主的线上平台</div>
                </li>
                <li class="resolve-case-item" @click="clickCaseItem(4)">
                    <img src="@/assets/img/develop/resolve_case_industry_5.png">
                    <div class="resolve-case-item-title">企业C2C平台</div>
                    <div class="resolve-case-item-des">适用于C2C交易平台，用户既可能是买家，又可能是卖家，资金在用户账户中流转</div>
                </li>
                <li class="resolve-case-item" @click="clickCaseItem(5)">
                    <img src="@/assets/img/develop/resolve_case_industry_6.png">
                    <div class="resolve-case-item-title">SAAS商城类软件服务商</div>
                    <div class="resolve-case-item-des">适用于按照交易流水收取服务费的商城类、交易类SAAS软件服务商</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Develop",
        methods : {
            clickToolsItem: function (idx) {
                alert(idx);
            },
            clickCaseItem: function (idx) {
                alert(idx);
            }
        }
    }
</script>

<style scoped>

    @import "../../assets/css/base.css";

    .margin-25 {
        margin-top: 25px;
    }

    .bottom_hint {
        width: 100px;
        height: 4px;
        margin: 16px auto auto;
        background: #4183D7;
    }

    .top-banner {
        position: relative;
        width: 100%;
        height: 340px;
        background: url("../../assets/img/develop/develop_back_banner.png") no-repeat;
        background-size:cover;
        z-index: -1;
    }

    .develop-tools {
        margin-top: -242px;
        text-align: center;
    }

    .develop-resolve-case {
        margin-top: 50px;
        text-align: center;
    }

    .develop-tools-title,
    .resolve-case-title {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSCRegular;
        color: #3A404D;
        line-height: 40px;
    }

    .face-tools-list,
    .resolve-case-list {
        margin:0;
        display: flex;
        justify-content: space-around;
        padding-left: 100px;
        padding-right: 100px;
        flex-wrap: wrap;
    }

    .resolve-case-list {
        padding-bottom: 100px;
    }

    .face-tools-item,
    .resolve-case-item {
        margin-top: 40px;
        margin-left: 30px;
        background: #F2F6FF;
        border-radius: 2px;
        padding: 23px 30px 45px;
        width: 25%;
        min-width: 25%;
        max-width: 25%;
        flex-wrap:wrap;
    }

    .face-tools-item img,
    .resolve-case-item img {
        width: 50px;
    }
    .face-tools-item-title,
    .resolve-case-item-title {
        margin-top: 20px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3A404D;
    }

    .face-tools-item-des,
    .resolve-case-item-des {
        margin-top: 10px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3A404E;
        line-height: 22px;
    }

</style>